import { Exclude } from "class-transformer";
import { CreateQuantityReserveDto } from "./CreateQuantityReserveDto";

@Exclude()
export class UpdateQuantityReserveDto extends CreateQuantityReserveDto {}
